import LensStats from './LensStats';
import TrendsGraph from './Trends.Graph';
import { genderRatio, topAgeRanges, topCities } from '../../ChartData';
import GenderRatioGraph from './GenderRatio.Graph';
import ProductsList from './LensList';

function LensInsights() {
    return (
        <>
            <LensStats />

            <div className="grid grid-cols-3 gap-x-3 mx-5 mt-4">
                <TrendsGraph 
                    pageTitle={'Top Cities'} 
                    graphData={topCities} 
                />

                <TrendsGraph 
                    pageTitle={'Top Age Ranges'} 
                    graphData={topAgeRanges} 
                />

                <GenderRatioGraph 
                    genderRatioGraphData={genderRatio} 
                />
            </div>

            <ProductsList />
        </>
    );
}

export default LensInsights;
